module.exports = __webpack_public_path__ + "img/md-dark-indigo.04096e4e.svg";